import React, { useEffect, useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

export default function MandatesMf() {
  /* ------------------ STATIC DATA ------------------ */
  const [mandates, setMandates] = useState([
    {
      id: "MAND1001",
      bank: "HDFC Bank",
      maxAmount: 100000,
      createdOn: "05 Jan 2026",
      status: "Approved",
      signature: "Completed",
      sipActive: true,
    },
    {
      id: "MAND1002",
      bank: "ICICI Bank",
      maxAmount: 50000,
      createdOn: "10 Jan 2026",
      status: "Pending",
      signature: "Awaiting",
      sipActive: false,
    },
  ]);

  /* ------------------ STATES ------------------ */
  const [showCreate, setShowCreate] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [newMandate, setNewMandate] = useState({
    bank: "",
    amount: "",
  });

  /* ------------------ WEBHOOK SIMULATION ------------------ */
  useEffect(() => {
    const timer = setTimeout(() => {
      setMandates((prev) =>
        prev.map((m) =>
          m.status === "Pending"
            ? { ...m, status: "Approved", signature: "Completed" }
            : m
        )
      );
    }, 6000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9" }}>
          {/* Header */}
          <div className="card shadow-sm p-4 mb-3">
            <h3 className="text-primary">Mandates</h3>

            <nav style={{ "--bs-breadcrumb-divider": "none" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>
                   <li className="breadcrumb-item">
                  <NavLink to="/clientmutualfunds">Mutual Funds</NavLink> /
                </li>
                <li className="breadcrumb-item active">Mandates</li>
              </ol>
            </nav>
          </div>

          {/* Create Button */}
          <div className="text-end mb-3">
            <button className="btn btn-primary" onClick={() => setShowCreate(true)}>
              + Create Mandate
            </button>
          </div>

          {/* ------------------ DESKTOP TABLE ------------------ */}
          <div className="d-none d-md-block card shadow-sm">
            <table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>Bank</th>
                  <th>Limit</th>
                  <th>Status</th>
                  <th>Signature</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {mandates.map((m) => (
                  <tr key={m.id}>
                    <td>{m.id}</td>
                    <td>{m.bank}</td>
                    <td>₹ {m.maxAmount.toLocaleString()}</td>
                    <td>
                      <span className={`badge ${m.status === "Approved" ? "bg-success" : "bg-warning text-dark"}`}>
                        {m.status}
                      </span>
                    </td>
                    <td>
                      <span className={`badge ${m.signature === "Completed" ? "bg-success" : "bg-secondary"}`}>
                        {m.signature}
                      </span>
                    </td>
                    <td>
                      <button className="btn btn-sm btn-outline-danger" disabled={m.sipActive}>
                        Cancel
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* ------------------ MOBILE CARD VIEW ------------------ */}
          <div className="d-md-none">
            {mandates.map((m) => (
              <div key={m.id} className="card shadow-sm mb-3 p-3">
                <p><strong>ID:</strong> {m.id}</p>
                <p><strong>Bank:</strong> {m.bank}</p>
                <p><strong>Limit:</strong> ₹ {m.maxAmount.toLocaleString()}</p>
                <p>
                  <strong>Status:</strong>{" "}
                  <span className={`badge ${m.status === "Approved" ? "bg-success" : "bg-warning text-dark"}`}>
                    {m.status}
                  </span>
                </p>
                <p>
                  <strong>Signature:</strong>{" "}
                  <span className={`badge ${m.signature === "Completed" ? "bg-success" : "bg-secondary"}`}>
                    {m.signature}
                  </span>
                </p>
                <button className="btn btn-outline-danger btn-sm" disabled={m.sipActive}>
                  Cancel
                </button>
              </div>
            ))}
          </div>

          {/* ------------------ CREATE MANDATE MODAL ------------------ */}
          {showCreate && (
            <div className="modal fade show d-block" style={{ background: "#0008" }}>
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5>Create Mandate</h5>
                    <button className="btn-close" onClick={() => setShowCreate(false)} />
                  </div>

                  <div className="modal-body">
                    <select
                      className="form-select mb-3"
                      onChange={(e) => setNewMandate({ ...newMandate, bank: e.target.value })}
                    >
                      <option>Select Bank</option>
                      <option>HDFC Bank</option>
                      <option>ICICI Bank</option>
                    </select>

                    <input
                      type="number"
                      className="form-control"
                      placeholder="Max Amount"
                      onChange={(e) => setNewMandate({ ...newMandate, amount: e.target.value })}
                    />
                  </div>

                  <div className="modal-footer">
                    <button
                      className="btn btn-primary"
                      onClick={() => {
                        setShowCreate(false);
                        setShowOtp(true);
                      }}
                    >
                      Proceed
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ------------------ OTP MODAL ------------------ */}
          {showOtp && (
            <div className="modal fade show d-block" style={{ background: "#0008" }}>
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5>OTP Verification</h5>
                    <button className="btn-close" onClick={() => setShowOtp(false)} />
                  </div>

                  <div className="modal-body">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter OTP"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                    />
                  </div>

                  <div className="modal-footer">
                    <button
                      className="btn btn-success"
                      onClick={() => {
                        setMandates([
                          ...mandates,
                          {
                            id: `MAND${1000 + mandates.length + 1}`,
                            bank: newMandate.bank,
                            maxAmount: Number(newMandate.amount),
                            createdOn: "Today",
                            status: "Pending",
                            signature: "Awaiting",
                            sipActive: false,
                          },
                        ]);
                        setShowOtp(false);
                      }}
                    >
                      Verify & Create
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Info */}
          <div className="alert alert-info mt-4">
            Mandate approval & signature status updates automatically via provider webhook.
          </div>
        </div>
    </>
  );
}
